export default __webpack_public_path__ + "static/media/car.bfaab223.svg";